const SEARCH_FIELD_SELECTOR = '.select2-container--open .select2-search__field';

$(function () {
    const $select = $('#searchBar-select');
    if ($select.length === 0) {
        return;
    }

    const title = $select.data('t-title');
    let lastSearchString = null;

    $select.select2({
        ajax: {
            url: $select.data('search-url'),
            dataType: 'json',
            delay: 500,
            data: (params) => ({
                query: params.term,
                action: 'search',
            }),
            cache: true,
        },
        escapeMarkup: (markup) => markup,
        templateResult: (data) => {
            if (data.children !== undefined) {
                return $('<span></span>').attr('id', data.groupId || '').text(data.text);
            }

            return data.text || data.title || data.url || '---';
        },
        templateSelection: () => title,
        minimumInputLength: 2,
        placeholder: $select.data('t-placeholder'),
        allowClear: true,
        closeOnSelect: false,
        dropdownAutoWidth: true,
    });

    $select.on('select2:select', (event) => {
        const data = event.params.data;
        if (!data?.url) {
            return;
        }

        window.open(data.url, '_blank');
        $(`li:contains("${data.text}") .select2-results__option--highlighted.select2-results__option[aria-selected=true][role="treeitem"]`)
            .attr('aria-selected', false);
    });

    $select.on('select2:open', () => {
        const $field = $(SEARCH_FIELD_SELECTOR);
        $field.val(lastSearchString).trigger('input');
        $field.off('input.omniSearch').on('input.omniSearch', (event) => {
            lastSearchString = event.currentTarget.value;
        });
    });
});
